// extracted by mini-css-extract-plugin
export default {"Loading":"bch_a bhp_a bhp_w bhp_j bhp_ul bhp_um bhp_fm"};